import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import APModal from 'components/Modal/APModal';
import BookingProcess from './Lead';

const BookingProcessModal = ({ open, onClose }) => {
  return (
    <APModal
      open={open}
      title="Customize your booking process."
      name="booking-process"
      className={clsx('customize-booking-modal__container')}
      onClose={onClose}
      actions={(
        <button className="button"
          onClick={onClose}
        >
          All set
        </button>
      )}
    >
      <BookingProcess />
    </APModal>
  );
};

BookingProcessModal.propTypes = {
  onClose: PropTypes.func,
};

BookingProcessModal.defaultProps = {};

export default BookingProcessModal;
